/* ══════════════════════════════════════════════════════════
   Manasa Publications — Shopify Theme JS
   Ghost nav, scroll-reveal, cart drawer, mobile nav, subscribe
   ══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Hero transparent nav ───────────────────────────── */
  if (window.location.pathname === '/' || window.location.pathname === '') {
    document.body.classList.add('has-hero');
  }

  /* ── Ghost / smart-scroll navbar ────────────────────── */
  const nav = document.querySelector('.mn-nav');
  if (nav) {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      const dir = y > lastY ? 'down' : 'up';
      lastY = y;
      if (y < 72) {
        nav.classList.remove('scrolled', 'hidden');
      } else {
        nav.classList.add('scrolled');
        if (dir === 'down') nav.classList.add('hidden');
        else nav.classList.remove('hidden');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Mobile nav overlay ──────────────────────────────── */
  const overlay  = document.querySelector('.mn-nav__overlay');
  const openBtns = document.querySelectorAll('[data-open-nav]');
  const closeBtn = document.querySelector('.mn-nav__overlay-close');

  if (overlay) {
    openBtns.forEach(btn => btn.addEventListener('click', () => overlay.classList.add('open')));
    closeBtn && closeBtn.addEventListener('click', () => overlay.classList.remove('open'));
    overlay.querySelectorAll('a').forEach(a => a.addEventListener('click', () => overlay.classList.remove('open')));
  }

  /* ── Cart drawer ─────────────────────────────────────── */
  const cartDrawer  = document.querySelector('.mn-cart-drawer');
  const cartOverlay = document.querySelector('.mn-cart-overlay');
  const cartBtns    = document.querySelectorAll('[data-open-cart]');
  const cartClose   = document.querySelector('[data-close-cart]');

  function openCart()  { cartDrawer && cartDrawer.classList.add('open'); cartOverlay && cartOverlay.classList.add('open'); }
  function closeCart() { cartDrawer && cartDrawer.classList.remove('open'); cartOverlay && cartOverlay.classList.remove('open'); }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* ── Scroll reveal ───────────────────────────────────── */
  const revealEls = document.querySelectorAll('.scroll-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    revealEls.forEach(el => io.observe(el));
  } else {
    revealEls.forEach(el => el.classList.add('revealed'));
  }

  /* ── Writers carousel drag-scroll ────────────────────── */
  const carousel = document.querySelector('.mn-writers__carousel');
  if (carousel) {
    let isDragging = false, startX, scrollLeft;
    carousel.addEventListener('mousedown', e => { isDragging = true; startX = e.pageX - carousel.offsetLeft; scrollLeft = carousel.scrollLeft; carousel.style.cursor = 'grabbing'; });
    carousel.addEventListener('mouseleave', () => { isDragging = false; carousel.style.cursor = ''; });
    carousel.addEventListener('mouseup',   () => { isDragging = false; carousel.style.cursor = ''; });
    carousel.addEventListener('mousemove', e => { if (!isDragging) return; e.preventDefault(); const x = e.pageX - carousel.offsetLeft; const walk = (x - startX) * 1.5; carousel.scrollLeft = scrollLeft - walk; });
  }

  /* ── Newsletter subscribe ────────────────────────────── */
  const subForms = document.querySelectorAll('[data-subscribe-form]');
  subForms.forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      const btn   = form.querySelector('button[type="submit"]');
      if (!input || !input.value) return;
      btn && (btn.disabled = true);
      btn && (btn.textContent = 'Subscribing…');
      try {
        // Shopify customer create via storefront OR just Klaviyo/Mailchimp endpoint
        // For now POST to Shopify contact form with tag
        const fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('customer[email]', input.value);
        fd.append('customer[tags]', 'newsletter');
        await fetch('/contact', { method: 'POST', body: fd });
        btn && (btn.textContent = '✓ Subscribed');
        input.value = '';
        setTimeout(() => { btn && (btn.disabled = false); btn && (btn.textContent = 'Subscribe'); }, 3000);
      } catch (err) {
        btn && (btn.textContent = 'Try Again');
        btn && (btn.disabled = false);
      }
    });
  });

  /* ── Add to Cart (AJAX) ──────────────────────────────── */
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const orig = btn.textContent;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });
      if (!res.ok) throw new Error('Cart add failed');

      btn.textContent = '✓ Added';
      updateCartCount();
      setTimeout(() => { openCart(); }, 300);
      setTimeout(() => { btn.disabled = false; btn.textContent = orig; }, 2000);
    } catch {
      btn.textContent = 'Error — Retry';
      btn.disabled = false;
    }
  });

  /* ── Cart count badge ────────────────────────────────── */
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      const badge = document.querySelector('.mn-nav__cart-badge');
      if (badge) {
        badge.textContent = data.item_count;
        badge.style.display = data.item_count > 0 ? 'flex' : 'none';
      }
      renderCartItems(data);
    } catch {}
  }

  /* ── Render cart items in drawer ─────────────────────── */
  function renderCartItems(data) {
    const body  = document.querySelector('.mn-cart-drawer__body');
    const total = document.querySelector('[data-cart-total]');
    if (!body) return;

    if (data.item_count === 0) {
      body.innerHTML = '<div class="mn-cart-drawer__empty">Your cart is empty</div>';
      if (total) total.textContent = '₹0';
      return;
    }

    const fmt = (cents) => '₹' + (cents / 100).toFixed(0);
    body.innerHTML = data.items.map(item => `
      <div class="cart-item">
        <img class="cart-item__img" src="${item.image}" alt="${item.title}" />
        <div class="cart-item__info">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__by">${item.vendor || ''}</div>
          <div class="cart-item__price">${fmt(item.line_price)}</div>
        </div>
        <button class="cart-item__remove" data-remove-key="${item.key}" aria-label="Remove">×</button>
      </div>
    `).join('');

    if (total) total.textContent = fmt(data.total_price);

    body.querySelectorAll('[data-remove-key]').forEach(btn => {
      btn.addEventListener('click', async () => {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.dataset.removeKey, quantity: 0 }) });
        updateCartCount();
      });
    });
  }

  /* ── Collection filter links ─────────────────────────── */
  document.querySelectorAll('[data-filter-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const url = new URL(window.location.href);
      const tag = btn.dataset.filterBtn;
      if (tag === 'All') {
        url.searchParams.delete('filter.p.tag');
      } else {
        url.searchParams.set('filter.p.tag', tag);
      }
      window.location.href = url.toString();
    });
  });

  /* ── Prize form ──────────────────────────────────────── */
  const prizeForm = document.querySelector('[data-prize-form]');
  if (prizeForm) {
    prizeForm.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = prizeForm.querySelector('[type="submit"]');
      btn && (btn.disabled = true, btn.textContent = 'Submitting…');
      try {
        const fd = new FormData(prizeForm);
        // Build mailto as fallback — Shopify Forms app handles POSTs in production
        const subject = encodeURIComponent('Manasa Lit Prize Submission — ' + (fd.get('full_name') || ''));
        window.location.href = `mailto:connect@manasapublications.com?subject=${subject}`;
        btn && (btn.textContent = 'Submitted — check your email app');
      } catch {
        btn && (btn.disabled = false, btn.textContent = 'Try Again');
      }
    });
  }

  /* ── Init cart count on page load ───────────────────── */
  updateCartCount();

})();
